import { C2Text, C4Text, T3Text } from "../text/CustomText";
import { Column, Padding, SizedBox } from "../CommonBaseComponents";
import Translate from "../../translate/Translate";
import { Theme } from "../../Theme";

function parseEntryName(name) {
    if (name === "Washer") {
        return Translate("common.washer");
    } else if (name === "Dryer") {
        return Translate("common.dryer");
    } else if (name === "Combo") {
        return Translate("common.combo");
    } else {
        return name;
    }
}

export const defaultGraphKeys = [
    { name: "Washer", color: Theme.color.cyan500 },
    { name: "Dryer", color: Theme.color.orange500 },
    { name: "Combo", color: Theme.color.indigo800 },
];

export const CustomLegend = (props) => {
    const { payload, paddingTop } = props;

    // 원하는 순서의 기준이 되는 배열
    const desiredOrder = defaultGraphKeys.map((key) => key.name);

    // payload를 desiredOrder에 따라 정렬
    const sortedPayload = [...payload].sort((a, b) => {
        return desiredOrder.indexOf(a.value) - desiredOrder.indexOf(b.value);
    });

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                paddingTop: paddingTop ?? "10px",
            }}
        >
            {sortedPayload.map((entry, index) => (
                <div key={`item-${index}`} style={{ display: "flex", alignItems: "center" }}>
                    {/* 1. 색상 아이콘 */}
                    <div
                        style={{
                            width: "8px",
                            height: "8px",
                            backgroundColor: entry.color, // 👈 데이터 색상
                            borderRadius: "100%",
                            marginRight: "6px",
                        }}
                    />
                    {/* 2. 텍스트 */}
                    <C4Text fontColor={Theme.color.gray500}>{parseEntryName(entry.value)}</C4Text>
                </div>
            ))}
        </div>
    );
};

export const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const total = payload.reduce((sum, entry) => sum + entry.value, 0);

        return (
            <div
                style={{
                    backgroundColor: Theme.color.white,
                    border: `1px solid ${Theme.color.zinc300}`,
                    borderRadius: "8px",
                    padding: "16px 20px",
                    boxShadow: `0 4px 12px ${Theme.color.black_01}`,
                }}
            >
                {/* 날짜 (Label) */}
                <C4Text fontColor={Theme.color.zinc850}>{label}</C4Text>

                {/* Total */}
                <Padding padding={"3px 0 15px"}>
                    <T3Text fontColor={Theme.color.zinc850}>
                        {Translate("common.total")} {total}
                    </T3Text>
                </Padding>

                {/* 항목 리스트 */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                    }}
                >
                    {payload.map((entry, index) => (
                        <div
                            key={`item-${index}`}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            {/* 1. 색상 막대 */}
                            <div
                                style={{
                                    width: "5px",
                                    height: "36px",
                                    backgroundColor: entry.color, // 👈 <Bar>의 fill 색상이 자동으로 들어옴
                                    borderRadius: "3px",
                                }}
                            />

                            {/* 2. 텍스트 (이름 + 값) */}
                            <Column alignItem={"flex-start"}>
                                <C4Text fontColor={Theme.color.gray500}>{parseEntryName(entry.name)}</C4Text>
                                <SizedBox height={"4px"} />
                                <C2Text fontColor={Theme.color.zinc850} fontWeight={"500"}>
                                    {entry.value.toLocaleString()}
                                </C2Text>
                            </Column>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return null;
};

export const SimpleTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div
                style={{
                    backgroundColor: Theme.color.white,
                    border: `1px solid ${Theme.color.zinc300}`,
                    borderRadius: "8px",
                    padding: "16px 20px",
                    boxShadow: `0 4px 12px ${Theme.color.black_01}`,
                }}
            >
                {/* 날짜 (Label) */}
                <C4Text fontColor={Theme.color.zinc850}>{label}</C4Text>

                <Padding padding={"3px 0"}>
                    <T3Text fontColor={Theme.color.zinc850}>
                        ฿
                        {payload[0].value.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </T3Text>
                </Padding>
            </div>
        );
    }

    return null;
};

export const CustomLabel = (props) => {
    const { x, y, width, value } = props;

    // 값이 0, null, undefined인 경우 라벨을 표시하지 않습니다.
    if (!value) {
        return null;
    }

    return (
        <text
            x={x + width / 2} // 막대의 가로 중앙
            y={y} // 막대의 상단 y 좌표
            dy={-6} // 막대 상단에서 6px 위로 이동
            fill={Theme.color.gray450} // 라벨 색상
            fontSize={12} // 폰트 크기
            textAnchor="middle" // 텍스트를 중앙 정렬
        >
            {value}
        </text>
    );
};
